import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import ImageUploadModal from 'components/images/ImageUploadModal';
import {closeNativeUploadModalAction, nativeUploadImageAction} from './actions';
import {fetchRemoteImage} from 'api/images';
import {isNoU} from 'utils/DBUtils';

/*
    Mounted once, at the page level (see pages/EditBreak/EditBreakPage.jsx), alongside
    ImageEditModalContainer. hoc/BreakImagePicker.jsx opens this for a field by dispatching
    openNativeUploadModalAction with that field's resource-hierarchy context; that context
    is read back here (state.images.nativeUploadContext) so onConfirm can attach the
    upload result to the right field.
*/
const mapStateToProps = (state) => {
    const context = state.images.nativeUploadContext;
    return {
        isOpen: !isNoU(context),
        imageType: context ? context.imageType : '',
        // Drives the modal's Info step "source required" rule -- same field
        // ImageEditModalContainer reads off the current edit Break for the
        // post-upload Edit Info form (see its mapStateToProps), sourced here
        // from the Break resource already carried on nativeUploadContext.
        sponsoredType: (context && context.rootResource) ? context.rootResource.sponsoredType : undefined,
        context
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

const mergeProps = (stateProps, dispatchProps) => ({
    imageType: stateProps.imageType,
    isOpen: stateProps.isOpen,
    sponsoredType: stateProps.sponsoredType,
    fetchRemoteImage,
    onCancel: () => dispatchProps.dispatch(closeNativeUploadModalAction()),
    onConfirm: (upload) => {
        const {context} = stateProps;
        if (isNoU(context)) {
            return;
        }
        dispatchProps.dispatch(nativeUploadImageAction(
            context.imageType,
            context.rootResource,
            context.forResourceId,
            context.resourcePath,
            context.fieldPath,
            context.field,
            context.parentIds,
            upload
        ));
    }
});

export default compose(
    setDisplayName('ImageUploadModalContainer'),
    connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(ImageUploadModal);



// WEBPACK FOOTER //
// ./public/pages/Images/ImageUploadModalContainer.jsx